import Axios from '../utils/axios-utils';


// get all Units
export const getAllUnits = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/units`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Units error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Units failed" }
        };
    }
};